import React from 'react'
import { removeToken} from '../storage'

export default class Logout extends React.Component {

  constructor(props) {
    super(props)
    removeToken()
    window.location.href = '/';
  }

  render() {
    return <p>Logging out...</p>
  }
}



// WEBPACK FOOTER //
// ./src/components/logout.js